import { render, staticRenderFns } from "./FindingsButton.vue?vue&type=template&id=1c21ce47&scoped=true&"
import script from "./FindingsButton.vue?vue&type=script&lang=js&"
export * from "./FindingsButton.vue?vue&type=script&lang=js&"
import style0 from "./FindingsButton.vue?vue&type=style&index=0&id=1c21ce47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21ce47",
  null
  
)

export default component.exports